import FloorplanCoordinatesField from './floorplan-coordinates-field';
export default FloorplanCoordinatesField;
